<template>
  <div>
    <b-row class="justify-content-center">
      <div class="col-md-4 col-sm-12 col-12">
        <router-view></router-view>
      </div>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import routeGuardMixins from "@/routeGuardMixins";
// import store from "@/store";

export default {
  name: "FarmerPagesLayout",
  // mixins: [routeGuardMixins],
  computed: {
    ...mapState({
      isLoggedIn: "isAuth",
      loggedInUser: "user"
    })
  }
};
</script>

<style scoped></style>
